import { useTranslation } from 'react-i18next';
import '../../../Asset/tabs/Cases/components/Filters/CasesSummaryPanel.scss';
import { useMemo } from 'react';
import { ReportPDFSummaries } from 'queries/report/contract';
import { CaseStatusEnum } from 'queries/cases/types';

interface Props {
  data: ReportPDFSummaries;
}

enum SummaryOrder {
  cases = 0,
  severity = 1,
  stage = 2,
}

const severityOrder: { [key: string]: SeverityNumber } = {
  very_high: 1,
  high: 2,
  medium: 3,
  low: 4,
};

type SummaryKeys = keyof typeof SummaryOrder;

const PdfStatus: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  const sortedKeys = useMemo(() => {
    return Object.keys(data).sort((a, b) => {
      const orderA = SummaryOrder[a as SummaryKeys] ?? 0;
      const orderB = SummaryOrder[b as SummaryKeys] ?? 0;
      return orderA - orderB;
    });
  }, [data]);

  return (
    <>
      {sortedKeys.map((statusKey) => (
        <div className="status-box">
          <strong className="box-title">{t(`pdf:summary.${statusKey}.title`)}</strong>
          <div className="box-items">
            {Object.keys(data[statusKey])
              .sort((a, b) => {
                const keyMap = statusKey === 'severity' ? severityOrder : CaseStatusEnum;
                const orderA = keyMap[a as keyof typeof keyMap] ?? 0;
                const orderB = keyMap[b as keyof typeof keyMap] ?? 0;
                return orderA - orderB;
              })
              .map((key) => (
                <div key={key} className="box-item">
                  <span className="box-value">{data[statusKey][key]}</span>
                  <span className="box-caption">{t(`pdf:summary.${statusKey}.${key}`)}</span>
                </div>
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default PdfStatus;
